import { API_CONFIG } from '@/page/config/base_config'

const item = {
  props: {
    isArrow: {
      type: Boolean,
      default: false
    },
    isCheckbox: {
      type: Boolean,
      default: true
    },
    checked: {
      type: Boolean,
      default: false
    },
    isHeadimg: {
      type: Boolean,
      default: false
    },
    isEndLine: {
      type: Boolean,
      default: false
    },
    isDel: {
      type: Boolean,
      default: false
    },
    isDown: {
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      default: () => {}
    },
    headimgSize: {
      type: String,
      default: '.8rem'
    },
    ids: {
      type: Array,
      default: () => []
    },
    total: {
      type: Object,
      default: () => {}
    },
    count: {
      type: Object,
      default: () => {}
    },
    allwaysCanDown: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    down() {
      return !!this.ids.includes(this.data.id) && !this.allwaysCanDown
    },
    avatar() {
      const {
        avatar
      } = this.data
      if (avatar) {
        return avatar.indexOf('http')
          ? avatar
          : `${API_CONFIG.FDFS_WEB_SERVER_URL}${avatar}`
      } else {
        return '/img/bg/vip3.png'
      }
    }
  },
  methods: {
    handleClick() {
      this.$emit('onClick', this.data)
    },
    handleDown() {
      if (!this.down) { this.$emit('onDown', this.data) }
    },
    handleDel() {
      this.$emit('onDel', this.data)
    }
  }
}

export default item
